// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__0prxG","span":"SuperEditableSpan_span__7GRMp","input":"SuperEditableSpan_input__WH7s+","pen":"SuperEditableSpan_pen__+UpB-"};